import { render } from "./PersonModal.vue?vue&type=template&id=3c3f085a&scoped=true"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"

import "./PersonModal.vue?vue&type=style&index=0&id=3c3f085a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3f085a"]])

export default __exports__